<div class="container-fluid">
  <div *ngIf="loading; else loaded">
    <app-loading></app-loading>
  </div>

  <ng-template #loaded>
    <!-- Page Heading with Icon -->
    <h1 class="h3 mb-2 text-gray-800">
      <i class="fas fa-exchange-alt"></i> {{ circulationI18n?.allTitleI18n }}
    </h1>
    
    <!-- Description -->
    <p class="lead">Manage and track the circulation of items efficiently. Use the tools provided to add, edit, view, contact, and delete circulation records seamlessly.</p>

    <!-- DataTales Example -->
    <div class="card shadow mb-4">
      <div class="card-body">
        <div class="table-responsive">
          
          <app-circulation-list
            (editEvent)="edit($event)"
            (viewEvent)="view($event)"
            (contactEvent)="contact($event)"
            (deleteEvent)="delete($event)"
            [circulations]="circulations$"
            [circulationI18n]="circulationI18n"
          ></app-circulation-list>
          <app-circulation-modal
            [email]="email"
            [circulationI18n]="circulationI18n"
            [circulations]="circulations$"
            [id]="id"
          ></app-circulation-modal>
        </div>
      </div>
    </div>
  </ng-template>
</div>

